import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import moment from "moment";
import variables from "../../variables.scss";
import Home from "../Home";
import Login from "../Login";
import ATCO from "../ATCO";
import Driver from "../Driver";
import Maintenance from "../Maintenance";
import GMC from "../GMC";
import PBRHOME from "../GMC/home";


const App = (props) => {

  useEffect(() => {
    // if (window.location.href.includes('/driver')) {

      console.log('firing heree')

      // Handler for the visibility change event
      const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
          window.location.reload();
          console.log('Idle time reload again ', moment().format('DD MMMM YYYY, HH:mm:ss'));
        }
      };
    
      // Add the event listener for visibility change
      document.addEventListener('visibilitychange', handleVisibilityChange);
    
      // Cleanup the event listener on component unmount
      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    // }
    
  }, []);

  return (
    <React.Fragment>
      <div
        style={{
          padding: 0,
          maxWidth: variables.appMaxWidth,
          boxShadow: "0 0 16px 2px rgba(0,0,0,.25)",
          marginRight: "auto",
          marginLeft: "auto",
          background: `${variables.appBackgroundColor}`,
          minHeight: "100vh",
          color: `${variables.appColor}`,
        }}
      >
        <Route path="/" exact component={Home} />
        <Route path="/login" exact component={Login} />
        <Route path="/atco" exact component={ATCO} />
        <Route path="/driver" exact component={Driver} />
        <Route path="/pbr" exact component={GMC} />
        <Route path="/pbrhome" exact component={PBRHOME} />
        <Route path="/maintenance" exact component={Maintenance} />
      </div>
    </React.Fragment>
  );
};

export default App;
